import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import EdInputModel from '@/models/ed-input.model';
import { lightOrDarkFromColor } from '@/utils/color-utils';

const MINUTES_PER_PLACEHOLDER = 60;
const MINUTES_THRESHOLD = 30;

@Component({
  name: 'ed-class-builder-block',
})
export default class EdClassBuilderBlockComponent extends Vue {
  @Prop({ default: () => [] }) readonly placeholders: any[];
  @Prop({ default: '' }) readonly label: string;
  @Prop({ default: null }) readonly entryId: number;
  @Prop({ default: '' }) readonly workingDay: string;
  @Prop({ required: true }) readonly scheduleBlockId: number;
  @Prop({ required: true }) readonly isAbleToEdit: boolean;
  @Prop({ required: true }) readonly duration: number;

  isSelected: any = EdInputModel('isSelected', false, {}, true);

  get seeMoreFontSize(): string {
    return this.duration <= MINUTES_THRESHOLD ? '8px' : '12px';
  }

  get placeholdersLength(): number {
    return this.placeholders.length;
  }

  get isLabelShown(): boolean {
    return this.placeholdersLength === 0 && !!this.label;
  }

  get maxPlaceHolder(): number {
    if (!this.duration || this.duration <= 0) return 1;
    return Math.ceil(this.duration / MINUTES_PER_PLACEHOLDER);
  }

  get placeholdersToShow(): any[] {
    return this.placeholders.slice(0, this.maxPlaceHolder);
  }

  get hasSeeMoreButton(): boolean {
    return this.placeholdersLength > this.maxPlaceHolder;
  }

  get shouldApplyFlexColumn(): boolean {
    return !(this.maxPlaceHolder === 1 && this.hasSeeMoreButton && this.duration <= MINUTES_THRESHOLD);
  }


  resetSelect() {
    this.isSelected.value = false;
  }

  lightOrDark(color) {
    return lightOrDarkFromColor(color)
  }

}